import { CbhIcon, Text } from "@clipboard-health/ui-components";
import { Stack } from "@mui/material";
import pluralize from "pluralize";

interface NewsFeedItemReactionsCountProps {
  count: number;
  showIcon?: boolean;
  includeText?: boolean;
}

export function NewsFeedItemReactionsCount(props: NewsFeedItemReactionsCountProps) {
  const { count, showIcon = false, includeText = false } = props;

  return (
    <Stack direction="row" alignItems="center" justifyContent="center" spacing={1}>
      {showIcon && <CbhIcon size="small" aria-label="reactions" type="like-outlined" />}
      <Text>
        {count}
        {includeText ? pluralize(" reaction", count) : ""}
      </Text>
    </Stack>
  );
}
